export function isUnrestrictedMachineUser(user) {
  if (!user) return false;
  return String(user.role || "").toLowerCase() === "admin";
}

export function getMachineId(value) {
  return String(value?._id || value?.machineId?._id || value?.machineId || value || "");
}

/** Profile machineAccess → Set or null when unrestricted / not configured. */
export function getProfileMachineAccessIds(user) {
  if (!user || isUnrestrictedMachineUser(user)) return null;
  const list = user.machineAccess || [];
  if (!Array.isArray(list) || list.length === 0) return new Set();
  return new Set(list.map((x) => getMachineId(x)).filter(Boolean));
}

/**
 * Effective allowed machines for EPC (client-side).
 * null = unrestricted (all machines).
 * empty Set = no machines allowed.
 */
export function mergeAllowedMachineIds(profileIds, assignmentIds) {
  if (profileIds === null && assignmentIds === null) return null;

  const merged = new Set();
  if (profileIds) profileIds.forEach((id) => merged.add(id));
  if (assignmentIds) assignmentIds.forEach((id) => merged.add(id));
  return merged;
}

export function isMachineAllowed(machineId, allowedIds) {
  if (allowedIds === null || allowedIds === undefined) return true;
  if (allowedIds.size === 0) return false;
  const id = getMachineId(machineId);
  return !!id && allowedIds.has(id);
}

export function filterMachinesByAccess(machines, allowedIds) {
  if (!allowedIds) return machines || [];
  return (machines || []).filter((m) => isMachineAllowed(m._id, allowedIds));
}
